
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0b1df2de\",\"scoped\":true,\"hasInlineConfig\":false}!scss-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./list.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./list.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0b1df2de\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./list.vue"),
  /* scopeId */
  "data-v-0b1df2de",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./vue/views/headOffice/goods/list.vue
// module id = 855
// module chunks = 0